import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import './header.scss';
import MmenuLight from 'mmenu-light';
export default /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
  var menuHolder, menu, drawer;
  return regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          menuHolder = document.querySelector('#nav');

          if (menuHolder) {
            menu = new MmenuLight(menuHolder, '(max-width: 767px)');
            menu.navigation({
              selected: 'is-active',
              title: 'Menu',
              theme: 'dark'
            });
            drawer = menu.offcanvas({
              position: 'left'
            });
            document.querySelector('a[href="#nav"]').addEventListener('click', function (event) {
              event.preventDefault();
              drawer.open();
            });
          }

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
}));